import { useEffect, useState } from 'react';

import {
  isAppIntegrityRequired,
  subscribeAppIntegrityRequired,
} from '@portal/services/appIntegrityRuntime';

export const useAppIntegrityRequired = (): boolean => {
  const [required, setRequired] = useState(isAppIntegrityRequired);

  useEffect(() => {
    setRequired(isAppIntegrityRequired());
    return subscribeAppIntegrityRequired(setRequired);
  }, []);

  return required;
};
